import classNames from 'classnames';
import { forwardRef } from 'react';
import type { CSSProperties, ReactNode, Ref } from 'react';
import styles from './Table.module.css';
const Table = forwardRef(function Table({
  children,
  className,
  head,
  resizing,
  id,
  touchEnabled,
  pivot,
  expandable: _,
  maxWidth,
  slot
}: {
  children: ReactNode;
  slot?: ReactNode;
  className?: string;
  head?: ReactNode;
  resizing?: boolean;
  id?: string;
  touchEnabled?: boolean;
  pivot?: boolean;
  expandable?: boolean;
  maxWidth?: string;
}, ref: Ref<HTMLTableElement>) {
  return <div className={classNames(styles.container, styles.overflow, {
    [styles.firstColFixed!]: pivot
  })} style={{
    '--max-width': maxWidth
  } as CSSProperties}>
      <table className={classNames(styles.table, className, {
      [styles.resizing!]: resizing,
      [styles.touchEnabled!]: touchEnabled
    })} ref={ref} id={id}>
        {head && <thead>{head}</thead>}
        <tbody>{children}</tbody>
      </table>
      {slot}
    </div>;
});
export default Table;